<script> 
	// Stores 
	import { textSite, mailLocacao } from '../store.js';    
	import { afterUpdate } from 'svelte';     

	// Componentes
	import { Router, Link, link , Route }   from "svelte-routing";
	import PageHeader                       from "../components/PageHeader.svelte";
	import Forms                            from "../components/Forms.svelte";  

	// Code
	let titlePage = 'Ficha cadastral para Locatário';

	const estados = [{title:'RS',value:'RS'},{title:'AC',value:'AC'},{title:'AL',value:'AL'},{title:'AP',value:'AP'},{title:'AM',value:'AM'},{title:'BA',value:'BA'},{title:'CE',value:'CE'},{title:'DF',value:'DF'},{title:'ES',value:'ES'},{title:'GO',value:'GO'},{title:'MA',value:'MA'},{title:'MT',value:'MT'},{title:'MS',value:'MS'},{title:'MG',value:'MG'},{title:'PA',value:'PA'},{title:'PB',value:'PB'},{title:'PR',value:'PR'},{title:'PE',value:'PE'},{title:'PI',value:'PI'},{title:'RJ',value:'RJ'},{title:'RN',value:'RN'},{title:'RO',value:'RO'},{title:'RR',value:'RR'},{title:'SC',value:'SC'},{title:'SP',value:'SP'},{title:'SE',value:'SE'},{title:'TO',value:'TO'}];
	const estadoCivil = [{title:'Solteiro(a)',value:'Solteiro(a)'},{title:'Casado(a)',value:'Casado(a)'},{title:'Separado(a)',value:'Separado(a)'},{title:'Desquitado(a)',value:'Desquitado(a)'},{title:'Divorciado(a)',value:'Divorciado(a)'},{title:'Viúvo(a)',value:'Viúvo(a)'},{title:'Amasiado(a)',value:'Amasiado(a)'},{title:'Outros',value:'Outros'}];
	let fields = [
		{
			name: 'assessor',
			title: 'Assessor',
			rowclass: 'w-50'
		},
		{
			name: 'cod-imovel',
			title: 'Código do imóvel *',
			required: 'required',
			rowclass: 'w-50'
		},
		{
			name: 'end-pretendido',
			title: 'Endereço do imóvel pretendido *',
			required: 'required',
		},
		{
			name: 'aluguel-pretendido',
			title: 'Aluguel R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'condominio-pretendido',
			title: 'Condomínio *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'iptu-pretendido',
			title: 'IPTU R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'total-pretendido',
			title: 'Total R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'nome',
			title: 'Nome completo *',
			required: 'required',
			rowclass: 'w-70',
		},
		{
			name: 'sexo',
			title: 'Gênero *',
			required: 'required',
			rowclass: 'w-30',
			type: 'select',
			selectValues: [
				{
					title: 'Feminino',
					value: 'Feminino'
				},
				{
					title: 'Masculino',
					value: 'Masculino'
				},
			]
		},
		{
			name: 'endereco',
			title: 'End. Rua/Av. *',
			required: 'required',
			rowclass: 'w-70'
		},
		{
			name: 'telefone',
			title: 'Telefone *',
			required: 'required',
			classe: 'mask-telefone',
			rowclass: 'w-30'
		},
		{
			name: 'bairro',
			title: 'Bairro *',
			required: 'required',
			rowclass: 'w-30'
		},
		{
			name: 'cidade',
			title: 'Cidade *',
			required: 'required',
			rowclass: 'w-30'
		},
		{
			name: 'uf',
			title: 'Estado *',
			required: 'required',
			rowclass: 'w-20',
			type: 'select',
			selectValues: estados
		},
		{
			name: 'cep',
			title: 'CEP *',
			required: 'required',
			rowclass: 'w-20',
			classe: 'mask-cep'
		},
		{
			name: 'email',
			title: 'E-mail *',
			required: 'required',
		},
		{
			name: 'celular',
			title: 'Celular *',
			required: 'required',
			classe: 'mask-telefone',
			rowclass: 'w-25'
		},
		{
			name: 'dt-nascimento',
			title: 'Data Nascimento *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-data'
		},
		{
			name: 'nacionalidade',
			title: 'Nacionalidade *',
			required: 'required',
			rowclass: 'w-50'
		},
		{
			name: 'naturalidade',
			title: 'Natural de *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'est-civil',
			title: 'Estado Civil *',
			required: 'required',
			rowclass: 'w-30',
			type: 'select',
			selectValues: estadoCivil
		},
		{
			name: 'n-dep',
			title: 'Nº Dep. *',
			required: 'required',
			rowclass: 'w-20',
		},
		{
			name: 'tempo-residencia',
			title: 'Há quanto reside no endereço citado? *',
			required: 'required',
			rowclass: 'w-40',
		},
		{
			name: 'tipo-imovel',
			title: 'Próprio',
			type: 'radio',
			rowclass: 'w-20',
		},
		{
			name: 'tipo-imovel',
			title: 'Alugado',
			type: 'radio',
			rowclass: 'w-20',
		},
		{
			name: 'imob',
			title: 'Imob. *',
			required: 'required',
			rowclass: 'w-20',
		},
		{
			title: 'Filiação',
			type: 'separator'
		},
		{
			name: 'mae-nome',
			title: 'Mãe *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'pai-nome',
			title: 'Pai ',
			rowclass: 'w-50',
		},
		{
			name: 'pais-endereco',
			title: 'Endereço *',
			required: 'required',
			rowclass: 'w-60',
		},
		{
			name: 'pais-telefone',
			title: 'Telefone *',
			required: 'required',
			rowclass: 'w-40',
		},
		{
			name: 'numero-pessoasResidir',
			title: 'Nº de pessoas que irão residir *',
			required: 'required',
		},
		{
			title: 'Documentos',
			type: 'separator'
		},
		{
			name: 'cpf',
			title: 'CPF *',
			required: 'required',
			classe: 'mask-cpf',
			rowclass: 'w-50',
		},
		{
			name: 'rg',
			title: 'RG *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'emprego-profissao',
			title: 'Profissão *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'emprego-empresa',
			title: 'Empresa em que trabalha *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'emprego-endereco',
			title: 'Endereço *',
			required: 'required',
			rowclass: 'w-70',
		},
		{
			name: 'emprego-telefone',
			title: 'Telefone *',
			required: 'required',
			rowclass: 'w-30',
			classe: 'mask-telefone'
		},
		{
			name: 'emprego-dtAdmissao',
			title: 'Data de Admissão *',
			required: 'required',
			rowclass: 'w-30',
			classe: 'mask-data'
		},
		{
			name: 'emprego-cargo',
			title: 'Cargo/Função *',
			required: 'required',
			rowclass: 'w-70',
		},
		{
			name: 'tipoRemuneracao',
			title: 'Salário',
			rowclass: 'w-20',
			classe: 'mask-valor',
			type: 'radio'
		},
		{
			name: 'tipoRemuneracao',
			title: 'Comissão',
			rowclass: 'w-20',
			classe: 'mask-valor',
			type: 'radio'
		},
		{
			name: 'tipoRemuneracao',
			title: 'Pró-Labore',
			rowclass: 'w-20',
			classe: 'mask-valor',
			type: 'radio'
		},
		{
			name: 'tipoRemuneracao',
			title: 'Aposentadoria',
			rowclass: 'w-20',
			classe: 'mask-valor',
			type: 'radio'
		},
		{
			name: 'tipoRemuneracao',
			title: 'Alúgueis',
			rowclass: 'w-20',
			classe: 'mask-valor',
			type: 'radio'
		},
		{
			name: 'emprego-valor',
			title: 'Valor Total R$ *',
			required: 'required',
		},
		{
			title: 'Identificação do cônjugue',
			type: 'separator'
		},
		{
			name: 'conjugue-nome',
			title: 'Nome completo ',
		},
		{
			name: 'conjugue-registro',
			title: 'Reg. Casamento ',
		},
		{
			name: 'conjugue-rg',
			title: 'RG ',
			rowclass: 'w-50',
		},
		{
			name: 'conjugue-cpf',
			title: 'CPF ',
			classe: 'mask-cpf',
			rowclass: 'w-50',
		},
		{
			name: 'conjugue-profissao',
			title: 'Profissão ',
			rowclass: 'w-50',
		},
		{
			name: 'conjugue-empresa',
			title: 'Empresa em que trabalha ',
			rowclass: 'w-50',
		},
		{
			name: 'conjugue-endereco',
			title: 'Endereço ',
			rowclass: 'w-50',
		},
		{
			name: 'conjugue-telefone',
			title: 'Telefone ',
			rowclass: 'w-25',
			classe: 'mask-telefone',
		},
		{
			name: 'conjugue-salario',
			title: 'Salário',
			rowclass: 'w-25',
			classe: 'mask-valor',
		},
		{
			name: 'conjugue-email',
			title: 'E-mail',
		},
	];

	const message = `Ficha Cadastral Locatário | Pessoa Física - Enviado pelo Site
<hr>
<p><b>Assessor:</b> {assessor}</p>
<p><b>Código do imóvel:</b> {cod-imovel}</p>
<p><b>Endereço do imóvel pretendido:</b> {end-pretendido}</p>
<p><b>Aluguel R$:</b> {aluguel-pretendido}</p>
<p><b>Condomínio R$:</b> {condominio-pretendido}</p>
<p><b>IPTU R$:</b> {iptu-pretendido}</p>
<p><b>Total R$:</b> {total-pretendido}</p>
<p><b>Nome Completo:</b> {nome}</p>
<p><b>Sexo:</b> {sexo}</p>
<p><b>Endereço:</b> {endereco}</p>
<p><b>Telefone:</b> {telefone}</p>
<p><b>Bairro:</b> {bairro}</p>
<p><b>Cidade:</b> {cidade}</p>
<p><b>Estado:</b> {uf}</p>
<p><b>E-mail:</b> {email}</p>
<p><b>CEP:</b> {cep}</p>
<p><b>Celular:</b> {celular}</p>
<p><b>Data Nascimento:</b> {dt-nascimento}</p>
<p><b>Necionalidade:</b> {nacionalidade}</p>
<p><b>Natural de:</b> {naturalidade}</p>
<p><b>Estado Civil</b> {est-civil}</p>
<p><b>Nº Dep.: </b> {n-dep}</p>
<p><b>Há quanto tempo reside no endereço citado?:</b> {tempo-residencia}</p>
<p><b>Tipo de Imóvel:</b> {tipo-imovel}</p>
<p><b>Imob:</b> {imob}</p>
<br>
<h2><b>FILIAÇÃO:</b></h2>     
<p><b>Pai:</b> {pai-nome}</p>
<p><b>Mãe:</b> {mae-nome}</p>
<p><b>Endereço:</b> {pais-endereco}</p>
<p><b>Telefone:</b> {pais-telefone}</p>
<p><b>Nº de pessoa que irão residir:</b> {numero-pessoasResidir}</p>
<br>
<h2><b>DOCUMENTOS:</b></h2> 
<p><b>CPF:</b> {cpf}</p>
<p><b>RG:</b> {rg}</p>
<p><b>Profissão:</b> {emprego-profissao}</p>
<p><b>Empresa em que trabalha:</b> {emprego-empresa}</p>
<p><b>Endereço:</b> {emprego-endereco}</p>
<p><b>Telefone:</b> {emprego-telefone}</p>
<p><b>Data de admissão:</b> {emprego-dtAdmissao}</p>
<p><b>Cargo/função:</b> {emprego-cargo}</p>
<p><b>Tipo Salário:</b> {tipoRemuneracao}</p>
<p><b>Valor:</b> {emprego-valor}</p>
<br>
<h2><b>IDENTIFICAÇÃO DO CÔNJUGUE:</b></h2>
<p><b>Nome completo:</b> {conjugue-nome}</p>
<p><b>Reg. Casamento:</b> {conjugue-registro}</p>
<p><b>CPF:</b> {conjugue-cpf}</p>
<p><b>RG:</b> {conjugue-rg}</p>
<p><b>Profissão:</b> {conjugue-profissao}</p>
<p><b>Empresa em que trabalha:</b> {conjugue-emprego}</p>
<p><b>Tel.:</b> {conjugue-telefoneEmprego}</p>
<p><b>Endereço:</b> {conjugue-enderecoEmprego}</p>
<p><b>Salário:</b> {conjugue-salario}</p>
<p><b>E-mail:</b> {conjugue-email}</p> 
<hr>
<p><b>$info</b>}</p>`;

	let loading = false;
	function send() {
		loading = true;
	}    

	let destiny = $mailLocacao;
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<p class="text-center">
		Pessoa Física
	</p>
	<div class="offset-md-1 col-md-10 pl-0 pr-0">        
		<hr class="line-separator">
		<Forms fields={fields} destiny={destiny} subjectTitle="{titlePage}" {message} htmlbody={true} />
	</div>
</div>